import type { Cookiebot } from '@/ts/types/cookiebot';

/**
 * Whenever cookiebot consent changes, refresh the page
 */
const handleConsentChange = () => {
  const Cookiebot = window.Cookiebot as Cookiebot;

  if (Cookiebot.changed && Cookiebot.hasResponse) {
    window.location.reload();
  }
};

export default async function init() {
  window.addEventListener('CookiebotOnConsentReady', handleConsentChange);
}
